var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "editCatTagsForm",
          attrs: { model: _vm.editCatTagsForm, "label-width": "120px" }
        },
        [
          [
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { label: "品种分类", name: "first" } },
                  [
                    _vm._l(_vm.editCatTagsForm.tags, function(tag) {
                      return _c(
                        "el-tag",
                        {
                          key: tag.id,
                          staticClass: "link",
                          attrs: { closable: "", "disable-transitions": false },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.handleLink(tag.id)
                            },
                            close: function($event) {
                              return _vm.handleClose(tag)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(tag.tag) +
                              "\n            "
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.handleLink()
                          }
                        }
                      },
                      [_vm._v("新增")]
                    )
                  ],
                  2
                )
              ],
              1
            )
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }